export default __webpack_public_path__ + "static/media/Draw-Quiz.3a364741.gif";